// extracted by mini-css-extract-plugin
export default {"dotsWrapper":"_f6f87122"};